import { appFields } from 'constants/appFields';

export const AppId = {
  accessor: appFields.APPID,
  footerSpan: 0,
  Header: 'ID',
  minWidth: 26,
};
